import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { QuickActionButton } from 'base-components';
import { Link, withRouter } from 'react-router-dom';
import { Trans } from 'lingui-react';

import messages from './messages';

export function RequestServiceButton({ match: { params: { assetId } } }) {
  const query = qs.stringify({ assetId }, { addQueryPrefix: true, skipNulls: true });
  return (
    <Link to={`/service-requests/new${query}`}>
      <QuickActionButton>
        <QuickActionButton.Icon modifiers={['left']} name="wrench" />
        <QuickActionButton.Text>
          <Trans id={messages.title} />
        </QuickActionButton.Text>
      </QuickActionButton>
    </Link>
  );
}

RequestServiceButton.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      assetId: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(RequestServiceButton);



// WEBPACK FOOTER //
// ./compositions/RequestServiceButton/index.js